import React, { useState } from "react";
import whychooseus from "images/whychooseus.png";

const benefits = [
  {
    title: "Inspection",
    description:
      "Car must be currently registered and may need an inspection",
  },
  {
    title: "Model year",
    description:
      "We accept vehicles 2017 and newer, with less than 100,000 miles",
  },
  {
    title: "Protection",
    description:
      "Your car is protected with comprehensive insurance while it's rented.",
  },
];

const WhyChooseUs = () => {
  const [activeIndex, setActiveIndex] = useState<any>();

  return (
    <section className="flex flex-col lg:flex-row items-center justify-between py-16">
      {/* Left Side - Text & Features */}
      <div className="lg:w-1/2 space-y-6">
        <h2 className="text-3xl md:text-5xl font-bold text-[#040401]]">
          Car Criteria
        </h2>
        <p className="text-md text-[#1B1F26B8]">
          Ensuring quality and performance
        </p>

        {/* Feature List */}
        <ul className="space-y-6">
          {benefits.map((benefit, index) => (
            <li key={index} className="flex items-start space-x-4">
              <svg
                className="flex-shrink-0 mt-1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#E6F7FF" />
                <path
                  d="M16.5 8.5L10.5 14.5L7.5 11.5"
                  stroke="#1E90FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div>
                <h3 className="text-lg font-semibold text-gray-700">
                  {benefit.title}
                </h3>
                <p className="text-gray-500">{benefit.description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="relative  mt-10 lg:mt-0">
        <img
          src={whychooseus}
          alt="Happy car rental customer"
          className="rounded-xl w-full max-w-lg mx-auto"
        />
      </div>
    </section>
  );
};

export default WhyChooseUs;
